"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickFilters = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const react_1 = require("react");
const QuickFilterItem_1 = require("./QuickFilterItem");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const react_redux_1 = require("react-redux");
const ListerSelector_1 = require("../../../redux/lister/selectors/ListerSelector");
const AnalyticsActions_creators_1 = require("../../../redux/analytics/actions/AnalyticsActions.creators");
const QuickFilters = () => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.product);
    const quickLinks = (0, react_redux_1.useSelector)((0, ListerSelector_1.makeGetQuickLinks)());
    const dispatch = (0, react_redux_1.useDispatch)();
    const hasQuickLinks = quickLinks && quickLinks.length > 0;
    (0, react_1.useEffect)(() => {
        dispatch(AnalyticsActions_creators_1.analyticsActions.listerHasQuickLinks(hasQuickLinks));
    }, []);
    if (!hasQuickLinks) {
        return null;
    }
    const handleClick = (name) => {
        dispatch(AnalyticsActions_creators_1.analyticsActions.listerQuickLinkClick(name));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { inline: true, emphasized: true, children: t('product.lister.quickFilters.title') }), (0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { marginTop: 2 } }, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.ScrollableList, { direction: cotopaxi_1.ScrollDirection.HORIZONTAL, variant: cotopaxi_1.ScrollableListVariant.GRADIENT, touchOnly: true, dataAnalyticsBannerid: "product-lister-quicklinks", children: quickLinks.map(quickLink => ((0, jsx_runtime_1.jsx)(QuickFilterItem_1.QuickFilterItem, { quickLink: quickLink, onClick: handleClick }, `quickLink_${quickLink.linkName}`))) }) })] }));
};
exports.QuickFilters = QuickFilters;
